import * as React from 'react'
export const Ae = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" width="1em" height="1em" {...props}>
    <path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#009e49" d="M0 0h513v114H0z" />
    <path d="M0 228h513v114H0z" />
    <path fill="#ce1126" d="M0 0h171v342H0z" />
  </svg>
)
